<div class="inputTitle" *ngIf="label">
  <span>{{label}}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>
<div [class.lightning]="beLight" class="numDiv" [class.d-none]="!isEditable">
  <mat-form-field [class.has-errors]="errors?.length" appearance="outline" [hidden]="!isEditable"
    [class.errorBorder]="errors?.length" (focusout)="onFocusOut($event)">
    <input matInput type="number" [name]="name" [(ngModel)]="data" [id]="name" [min]="minValue" [max]="maxValue"
      [placeholder]="placeholder" [disabled]="disabled" [maxlength]="maxlength" [minlength]="minlength"
      oninput="if (value.length > maxLength) value = value.slice(0, maxLength);" (keypress)="default($event)"
      autocomplete="off">
    <span matSuffix class="numVal">{{numVal}}</span>
    <i *ngIf="containerNum" matSuffix class="flaticon-container-solid inputContainer"></i>
  </mat-form-field>
</div>

<div class="viewLable" *ngIf="!isEditable">
  <!-- <span>{{_data==null || _data=="" ? '-' : _data}} {{_data!=null || _data=="" ? numVal : ''}}</span> -->
  <span>
    {{ getDisplay() }} {{_data!=null || _data=="" ? numVal : ''}}
  </span>
</div>

<ul *ngIf="errors?.length" class="errorList">
  <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>